import fetch from './fetch'

export default {
  getPersonNotes (payload) {
    let request = fetch({
      url: `/note`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getNotes (payload) {
    let request = fetch({
      url: `/note`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getNote (payload) {
    let request = fetch({
      url: `/note`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createNote (payload) {
    let request = fetch({
      url: `/note/`,
      method: 'post',
      data: payload || {}
    })
    return request.call()
  },
  updateNote (payload) {
    var noteId = payload.id

    let request = fetch({
      url: `/note/` + noteId,
      method: 'patch',
      data: payload
    })

    return request.call()
  }

}



// WEBPACK FOOTER //
// ./src/api/note.js